import { redact } from '../../utils/redact.mjs'
import { GroupSite } from '../../Submission/GroupSite.mjs'
import { FilterGroup } from '../../SessionUrlFilters/FilterGroup.mjs'

export function getRevealedSites(
  calculators,
  secrets,
  urls = null,
  timerWhitelist = [],
  filterGroup = new FilterGroup({}),
) {
  if (!calculators || !calculators.urlDataRc || !secrets) {
    return []
  }
  const sites =
    calculators?.urlDataRc?.toRevealedSitesArray(
      secrets,
      urls,
      timerWhitelist,
      filterGroup,
    ) || []
  for (let i = 0; i < sites.length; i++) {
    const site = sites[i]
    const timeline = calculators?.urlTimelinesRc?.dataMap[redact(site.url)]
    if (!timeline) continue
    const { startTimes, stopTimes } = timeline
    site.time = timeline.total
    site.firstFocus = startTimes[0]
    site.lastFocus = stopTimes[stopTimes.length - 1]
    site.faviconUrl = calculators?.faviconUrlRc?.getFaviconForUrl(
      site.url,
      secrets,
    )
  }

  return processSites2(sites, calculators.canonicalUrlsRc, secrets)
}

function groupGoogleDriveUrls(urls) {
  const productMap = {
    document: 'googleDocs',
    spreadsheets: 'googleSheets',
    presentation: 'googleSlides',
    forms: 'googleForms',
    drawings: 'googleDrawings',
    file: 'googleDriveFiles',
  }

  const result = {
    googleDocs: {},
    googleSheets: {},
    googleSlides: {},
    googleForms: {},
    googleDrawings: {},
    googleDriveFiles: {},
  }

  const urlPattern =
    /^https?:\/\/(?:[\w-]+\.)?google\.com\/(?:.*?\/)?(document|spreadsheets|presentation|forms|drawings|file)(?:\/u\/\d+)?\/d\/([^/]+)/

  for (const url of urls) {
    const match = url.match(urlPattern)
    if (match) {
      const [, product, fileId] = match
      const category = productMap[product]
      if (!result[category][fileId]) {
        result[category][fileId] = []
      }
      result[category][fileId].push(url)
    }
  }

  // prune out empty categories
  for (const key in result) {
    if (Object.keys(result[key]).length === 0) {
      delete result[key]
    }
  }

  return result
}

function createGoogleUrl(category, docId) {
  const baseUrls = {
    googleDocs: 'https://docs.google.com/document/d/',
    googleSheets: 'https://docs.google.com/spreadsheets/d/',
    googleSlides: 'https://docs.google.com/presentation/d/',
    googleForms: 'https://docs.google.com/forms/d/',
    googleDrawings: 'https://docs.google.com/drawings/d/',
    googleDriveFiles: 'https://drive.google.com/file/d/',
  }
  return baseUrls[category] + docId
}

// Here we attempt to combine like sites.
function processSites(sites) {
  const groupedGoogleDriveUrls = groupGoogleDriveUrls(
    new Set(sites.map((site) => site.url)),
  )
  console.log('Grouped Google Drive URLs:', groupedGoogleDriveUrls)
  const urlMap = sites.reduce((map, site) => {
    map[site.url] = site
    return map
  }, {})

  Object.keys(groupedGoogleDriveUrls).forEach((category) => {
    let documentIds = Object.keys(groupedGoogleDriveUrls[category])
    if (documentIds.length === 0) return
    // For each document ID, combine the URLs into a single GroupSite
    for (const docId of documentIds) {
      const urls = groupedGoogleDriveUrls[category][docId]
      const foundSites = urls.map((url) => urlMap[url])
      if (foundSites.length < 2) return
      const combinedSite = new GroupSite({
        url: createGoogleUrl(category, docId),
        sites: foundSites.reduce((acc, site) => {
          acc[site.url] = site.toJson()
          return acc
        }, {}),
      })
      sites = sites.filter((site) => !urls.includes(site.url))
      sites.push(combinedSite)
    }
  })

  for (let site of sites) {
  }

  return sites
}

// Here we attempt to combine like sites.
function processSites2(sites, canonicalUrlsRc, secrets) {
  const canonicalUrlMap = {}

  const newSites = []

  for (let site of sites) {
    const canonicalUrl = canonicalUrlsRc.getCanonicalUrl(
      secrets,
      redact(site.url),
    )
    if (canonicalUrl) {
      if (!canonicalUrlMap[canonicalUrl]) {
        canonicalUrlMap[canonicalUrl] = new GroupSite({
          url: canonicalUrl,
          sites: {},
        })
        newSites.push(canonicalUrlMap[canonicalUrl])
      }
      canonicalUrlMap[canonicalUrl].sites[site.url] = site
    } else {
      newSites.push(site)
    }
  }

  // console.log('Canonical URL Map:', canonicalUrlMap)

  return newSites
}
